export default __webpack_public_path__ + "../staticImages/winefinder-sprite-Aroma_geroestet-2x.png";